<template>
  <div class="">
    <div class="header">
      <div class="flexbox-between">
        <div>
          <div class="">{{ products.length }} 点の商品を選択</div>
          <div class="">※確定するにはエントリーするボタンを押してください</div>
        </div>
        <div>
          <button :disabled="products.length === 0" class="btn btn-warning" @click="$emit('openModalConfirm')">
            エントリーする
            <i class="fa fa-hand-o-right" aria-hidden="true"></i>
          </button>
        </div>
      </div>
      <div class="text-right">
        <a class="text--underline" @click="handleRemoveProducts()">すべて削除</a>
      </div>
    </div>
    <products
      :products="products"
      :isAdded="true"
      @handleRemoveProduct="handleRemoveProduct"
    />
  </div>
</template>

<script>
import Products from './Products'
export default {
  props: {
    products: {
      type: Array
    }
  },
  components: {
    Products
  },
  methods: {
    handleRemoveProduct (asin) {
      this.$emit('handleRemoveProduct', asin)
    },
    handleRemoveProducts () {
      this.$emit('handleRemoveProducts')
    }
  }
}
</script>
<style scoped>
.header {
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
  height: 85px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  .btn {
    font-size: 18px;
    padding: 6px 24px;
    font-weight: 600;
  }
}
@media (max-width: 425px) {
  .header {
    height: unset;
    .btn {
      font-size: 14px;
      padding: 6px;
    }
    .flexbox-between {
      justify-content: left;
      align-items: end;
      flex-direction: column;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/sale/components/SaleEntryAddedProducts.vue